// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section___4_2t","loading":"section_loading__58YdZ"};